// extracted by css-extract-rspack-plugin
export default {"formula":"B4pFY IUJkJ cahH4","formulaHeader":"C7JCy IXEGd _Uhde OK2kc","formulaTitle":"Z4_vD SJXBn","formulaDefinitionInner":"Mzv1r O4m07","formulaDefinition":"PciSp"};